/* 我的保理信息接口 */

import ajax from '../ajax';

export default {
  getMyBlItemInfoCount (params) { // 获取用户看板数据
    return ajax.get('/loanform/blitem/blLoanItemFrontApply/getMyBlItemInfoCountNew.ht', params);
  },
  getItemApplyList (params) {
    return ajax.get('/loanform/blitem/blLoanItemFrontApply/getItemApplyListNew.ht', params);
  },

  delFrontItem (params) {
    return ajax.postForm('/loanform/blitem/blLoanItemFrontApply/delFrontItem.ht', params);
  },

  getItemDetails (params) { // 项目详情接口
    return ajax.postForm('/loanform/blitem/blLoanItemFrontApply/getItemDetails.ht', params);
  },
  getPoolItemDetails (params) { // 项目详情接口
    return ajax.postForm('/loanform/blitem/blLoanItemFrontApply/getPoolItemDetails.ht', params);
  },
  getRepayList (params) { // 项目详情还款计划接口
    return ajax.postForm('/loanform/blfinance/blLoanItemFinanceRepay/getRepayList.ht', params);
  },
  getRepayDetails (parmas) { // 还款计划详情
    return ajax.postForm('/loanform/blfinance/blLoanItemFinanceRepay/getRepayDetails.ht', parmas);
  },
  getFrontVoucherInfoList (params) { // 凭证列表接口
    return ajax.postForm('/loanform/blitem/blLoanAccountVoucherInfo/getFrontVoucherInfoList.ht', params);
  },
  getFrontVoucherInfoDetails (params) { // 凭证详情
    return ajax.postForm('/loanform/blitem/blLoanAccountVoucherInfo/getFrontVoucherInfoDetails.ht', params);
  },
  signContract (params) { // 电子合同签名
    return ajax.postForm('/mobile/item/shortcutSignature/pdfSignatureCustomerBL.ht', params);
  },
  getCanPayMoney (params) { // 获取可融资申请金额-送货融资
    return ajax.get('/loanform/blfinance/blLoanPayApply/getCanPayMoney.ht', params);
  },
  applyLending (params) { // 提交融资放款申请-送货融资
    return ajax.postForm('/loanform/blfinance/blLoanPayApply/applyLending.ht', params);
  },
  loanPayApplyList (params) { // 获取融资申请列表-送货融资
    return ajax.get('/loanform/blfinance/blLoanPayApply/loanPayApplyList.ht', params);
  },
  getCanPayMoneyByBuyerIdForPool (params) { // 根据买方id获取可融资申请金额
    return ajax.get('/loanform/blfinance/blLoanPayApply/getCanPayMoneyByBuyerIdForPool.ht', params);
  }
};



// WEBPACK FOOTER //
// ./src/api/personalCenter/myloan_bl.js